window.PLTableInstall = function (id, isClickable, separator) {
  if (isClickable) {
    document.querySelectorAll(`table#${id}${separator}table tbody tr`).forEach(row => {
      if(row.dataset.clickable === "true" ){
        row.addEventListener('click', () => {
        const target = '#' + row.dataset.target.replace(/:/g, '\\:');
        htmx.trigger(target, 'row-click');
      });}
    });
  }

  document.querySelectorAll(`table#${id}${separator}table button`).forEach(item => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  document.querySelectorAll(`table#${id}${separator}table .dropdown-item`).forEach(item => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  document.querySelectorAll(`table#${id}${separator}table .dropdown-menu`).forEach(menu => {
    const wrapper = menu.closest('td');
    const button = wrapper?.querySelector('[data-bs-toggle="dropdown"]');

    if (wrapper && button) {
      wrapper.addEventListener('mouseleave', () => {
        if (menu.classList.contains('show')) {
          button.click();
        }
      });
    }
  });
}

console.log('PLTable has been installed');

